import React, { useEffect, useRef, useState } from "react";
import Header2 from "../components/Header2";
import { Link } from "react-router-dom";

const AccountNotification2 = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  const fileInputRef = useRef(null);

  // Load the selected image from localStorage on component mount
  useEffect(() => {
    const storedImage = localStorage.getItem("profileImage");
    if (storedImage) {
      setSelectedImage(storedImage);
    }
  }, []);

  const handleButtonClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setSelectedImage(reader.result); // Set the selected image as a base64 URL
        localStorage.setItem("profileImage", reader.result); // Save to localStorage
      };
      reader.readAsDataURL(file); // Read the file as a data URL
    }
  };

  // State for each checkbox
  const [checkboxes, setCheckboxes] = useState(() => ({
    checkbox1: JSON.parse(localStorage.getItem("checkbox1State")) || false,
    checkbox2: JSON.parse(localStorage.getItem("checkbox2State")) || false,
    checkbox3: JSON.parse(localStorage.getItem("checkbox3State")) || false,
    checkbox4: JSON.parse(localStorage.getItem("checkbox4State")) || false,
  }));

  // Save state to localStorage when it changes
  useEffect(() => {
    localStorage.setItem(
      "checkbox1State",
      JSON.stringify(checkboxes.checkbox1)
    );
    localStorage.setItem(
      "checkbox2State",
      JSON.stringify(checkboxes.checkbox2)
    );
    localStorage.setItem(
      "checkbox3State",
      JSON.stringify(checkboxes.checkbox3)
    );
    localStorage.setItem(
      "checkbox4State",
      JSON.stringify(checkboxes.checkbox4)
    );
  }, [checkboxes]);

  // Generic handler for checkbox state changes
  const handleCheckboxChange = (checkbox) => {
    setCheckboxes((prev) => ({
      ...prev,
      [checkbox]: !prev[checkbox],
    }));
  };

  const [alertVisible, setAlertVisible] = useState(false);

  const handleSaveChanges = () => {
    setAlertVisible(true); // Show the alert

    setTimeout(() => setAlertVisible(false), 6000); // Hide the alert after 3 seconds
  };

  const handleCloseAlert = () => {
    setAlertVisible(false); // Manually close the alert
  };

  return (
    <>
      <Header2 />

      {alertVisible && (
        <div
          style={{
            position: "absolute", // Overlay on top
            top: "14%",
            left: "50%",
            transform: "translateX(-50%)",
            backgroundColor: "orange",
            color: "white",
            padding: "10px 10px",
            borderRadius: "5px",
            textAlign: "center",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            // width: "400px",
            // boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
            zIndex: 1000,
          }}
        >
          {/* Tick Icon */}
          <div
            style={{
              backgroundColor: "white",
              color: "green",
              borderRadius: "50%",
              width: "24px",
              height: "24px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              marginRight: "10px",
              fontWeight: "bold",
              fontSize: "16px",
              border: "1px solid green",
            }}
          >
            ✓
          </div>
          <div className="fontmobil" style={{ flex: 1 }}>
            Your Account information has been updated
          </div>
          {/* Close Icon */}
          <div
            style={{
              cursor: "pointer",
              marginLeft: "10px",
              color: "white",
              fontWeight: "bold",
              fontSize: "18px",
            }}
            onClick={handleCloseAlert}
          >
            ×
          </div>
        </div>
      )}

      <div className="container " style={{ height: "830px" }}>
        <div className="row mb-5 ">
          <div className="d-flex flex-wrap justify-content-center   ">
            <div className="col-xl-3 textsmctr col-6 mx-auto  mt-5">
              {/* Header */}
              <div className="d-sm-flex  gap-2 gap-md-3 ">
                <input
                  type="file"
                  accept="image/*"
                  ref={fileInputRef}
                  style={{ display: "none" }} // Hide the input
                  onChange={handleFileChange} // Handle file change
                />
                <img
                  src={
                    selectedImage || require("../pages/image/addphotoicon.png")
                  } // Show user-selected image or default image
                  alt="Profile"
                  className="rounded-circle widimg "
                  width="119"
                  height="119"
                  //   style={{ width: "118px", height: "118px" }} // Set dimensions as needed
                  onClick={handleButtonClick} // Allow clicking on the image to upload a new one
                />
                <div>
                  <div
                    className=" mt-3 fw-bold fs-4 ftzpual text-dark "
                    style={{ lineHeight: "33.6px" }}
                  >
                    Paul Smith
                  </div>
                  <div>
                    <input
                      type="file"
                      accept="image/*"
                      ref={fileInputRef}
                      style={{ display: "none" }} // Hide the input
                      onChange={handleFileChange} // Handle file change
                    />
                    <button
                      type="button"
                      className="btn btnwid btn-secondary fs-5 fw-normal w-100 mt-2"
                      style={{
                        backgroundColor: "#888888",
                        maxWidth: "157px",
                        height: "38px",
                        border: "1px solid #383838",
                        lineHeight: "27.24px",
                      }}
                      onClick={handleButtonClick}
                    >
                      Update photo
                    </button>
                  </div>
                </div>
              </div>

              <div className=" cityzip textleft mx-md-4">
                <div
                  className=" fs-4 ftlink fw-normal"
                  style={{ lineHeight: "32.23px" }}
                >
                  <Link
                    to="/profile"
                    className="text-dark text-decoration-none "
                  >
                    Personal Profile
                  </Link>
                </div>
                <div
                  className="mt-4 fs-4 ftlink fw-normal"
                  style={{ lineHeight: "32.23px" }}
                >
                  <Link
                    to="/accountnotification"
                    className="text-dark text-decoration-none"
                  >
                    Account Notification
                  </Link>
                </div>
                <div
                  className="mt-4 ftlink fs-4 fw-normal"
                  style={{ lineHeight: "32.23px" }}
                >
                  <Link
                    to="/privacyaccount"
                    className="text-dark text-decoration-none"
                  >
                    Privacy
                  </Link>
                </div>

                <div
                  className="mt-4 fs-4 ftlink fw600 accotw"
                  style={{ lineHeight: "32.23px", width: "240px" }}
                >
                  <Link
                    to="/accountnotification"
                    className="text-dark text-decoration-none"
                  >
                    Account Notification
                  </Link>
                </div>
              </div>
            </div>

            <div className="col-md-9 col-12 mt-5 ">
              {/* BorderLine Horz */}

              <div
                className="text-dark mttttop   w-100"
                style={{
                  maxWidth: "760px",
                  rotate: "-90deg",
                  border: "2px solid",
                }}
              ></div>

              <div className="mtop mltop mx-5">
                <form className="textleft mx-auto ">
                  <div className="mbbom">
                    <label
                      htmlFor="name"
                      className="form-label text-dark ftzevtt fw600 fs-5 text-left"
                      style={{
                        lineHeight: "27.24px",
                      }}
                    >
                      Name<span style={{ color: "#E33629" }}>*</span>
                    </label>
                    <input
                      type="text"
                      className="form-control namewidd fw-normal fs-5 ftzevtt rounded-0 placeholder-login"
                      id="name"
                      required
                      style={{
                        border: "1px solid #6D6D6D",
                        width: "539px",
                        height: "40px",

                        lineHeight: "27.24px",
                        color: "#7B7B7B",
                      }}
                    />
                  </div>

                  <div className="mbbom">
                    <label
                      htmlFor="surname"
                      className="form-label text-dark ftzevtt fw600 fs-5 text-left"
                      style={{
                        lineHeight: "27.24px",
                      }}
                    >
                      Surname<span style={{ color: "#E33629" }}>*</span>
                    </label>
                    <input
                      type="text"
                      className="form-control namewidd fw-normal fs-5 ftzevtt rounded-0 placeholder-login"
                      id="surname"
                      required
                      style={{
                        border: "1px solid #6D6D6D",
                        width: "539px",
                        height: "40px",

                        lineHeight: "27.24px",
                        color: "#7B7B7B",
                      }}
                    />
                  </div>

                  <div className="mbbom">
                    <label
                      htmlFor="address"
                      className="form-label text-dark ftzevtt fw600 fs-5 text-left"
                      style={{
                        lineHeight: "27.24px",
                      }}
                    >
                      Address and house number
                      <span style={{ color: "#E33629" }}>*</span>
                    </label>
                    <input
                      type="text"
                      className="form-control namewidd fw-normal fs-5 ftzevtt rounded-0 placeholder-login"
                      id="address"
                      required
                      style={{
                        border: "1px solid #6D6D6D",
                        width: "539px",
                        height: "40px",

                        lineHeight: "27.24px",
                        color: "#7B7B7B",
                      }}
                    />
                  </div>

                  <div className="mbbom">
                    <label
                      htmlFor="city"
                      className="form-label text-dark ftzevtt fw600 fs-5 text-left"
                      style={{
                        lineHeight: "27.24px",
                      }}
                    >
                      City<span style={{ color: "#E33629" }}>*</span>
                    </label>
                    <input
                      type="text"
                      className="form-control namewidd fw-normal fs-5 ftzevtt rounded-0 placeholder-login"
                      id="city"
                      required
                      style={{
                        border: "1px solid #6D6D6D",
                        width: "539px",
                        height: "40px",

                        lineHeight: "27.24px",
                        color: "#7B7B7B",
                      }}
                    />
                  </div>

                  <div className="mbbom">
                    <label
                      htmlFor="zipcode"
                      className="form-label text-dark ftzevtt fw600 fs-5 text-left"
                      style={{
                        lineHeight: "27.24px",
                      }}
                    >
                      Zip code<span style={{ color: "#E33629" }}>*</span>
                    </label>
                    <input
                      type="text"
                      className="form-control namewidd fw-normal fs-5 ftzevtt rounded-0 placeholder-login"
                      id="zipcode"
                      required
                      style={{
                        border: "1px solid #6D6D6D",
                        width: "539px",
                        height: "40px",

                        lineHeight: "27.24px",
                        color: "#7B7B7B",
                      }}
                    />
                  </div>

                  <div className="mbbom">
                    <label
                      htmlFor="state"
                      className="form-label text-dark ftzevtt fw600 fs-5 text-left"
                      style={{
                        lineHeight: "27.24px",
                      }}
                    >
                      State / Province
                      <span style={{ color: "#E33629" }}>*</span>
                    </label>
                    <input
                      type="text"
                      className="form-control namewidd fw-normal fs-5 ftzevtt rounded-0 placeholder-login"
                      id="state"
                      required
                      placeholder="United Kingdom"
                      style={{
                        border: "1px solid #6D6D6D",
                        width: "539px",
                        height: "40px",

                        lineHeight: "27.24px",
                        color: "#7B7B7B",
                      }}
                    />
                  </div>

                  <div className="mbbom">
                    <label
                      htmlFor="phone"
                      className="form-label text-dark ftzevtt fw600 fs-5 text-left"
                      style={{
                        lineHeight: "27.24px",
                      }}
                    >
                      Phone<span style={{ color: "#E33629" }}>*</span>
                    </label>
                    <input
                      type="text"
                      className="form-control namewidd fw-normal fs-5 ftzevtt rounded-0 placeholder-login"
                      id="phone"
                      required
                      style={{
                        border: "1px solid #6D6D6D",
                        width: "539px",
                        height: "40px",

                        lineHeight: "27.24px",
                        color: "#7B7B7B",
                      }}
                    />
                  </div>
                </form>

                <div className="mb-5 pb-5  mt-5">
                  <button
                    className="w-100 mt-5 eventcrtwid fw600 fs-5 !text-white text-center rounded-1 border-0"
                    style={{
                      maxWidth: "167px",
                      height: "44px",
                      backgroundColor: "#34C3C9",
                    }}
                    onClick={handleSaveChanges}
                  >
                    Save Changes
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AccountNotification2;
